module.exports = __webpack_public_path__ + "img/balloon-left-sm.85a02124.svg";